module.exports = __webpack_public_path__ + "media/components/shared/static/enlarge-d3e717e2f47315fc78df211ba041646f.svg";